import React, { useState, useRef } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";

export default function VoiceRecorder({ onResult }) {
  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const mediaRecorderRef = useRef(null);
  const audioChunks = useRef([]);

  // Speech-to-text setup
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  const startRecording = async () => {
    setError("");
    resetTranscript();
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new window.MediaRecorder(stream);
      audioChunks.current = [];
      mediaRecorderRef.current.ondataavailable = event => {
        if (event.data.size > 0) audioChunks.current.push(event.data);
      };
      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunks.current, { type: "audio/wav" });
        setAudioURL(URL.createObjectURL(audioBlob));
        setLoading(true);
        setError("");
        // Send to backend for emotion prediction
        const formData = new FormData();
        formData.append("file", audioBlob, "recording.wav");
        try {
          const res = await fetch("http://127.0.0.1:5000/api/predict-emotion", {
            method: "POST",
            body: formData,
          });
          if (!res.ok) throw new Error("API error: " + res.status);
          const data = await res.json();
          console.log("Emotion API response:", data);
          if (onResult) onResult(data);
        } catch (err) {
          setError("Could not analyze emotion. Please try again.");
          console.error("Error uploading audio:", err);
          if (onResult) onResult({ emotion: "unknown" });
        }
        setLoading(false);
      };
      mediaRecorderRef.current.start();
      setRecording(true);
      // Start speech-to-text
      if (browserSupportsSpeechRecognition) {
        SpeechRecognition.startListening({ continuous: true, language: "en-US" });
      }
      // Auto-stop after 60 seconds
      setTimeout(() => stopRecording(), 60000);
    } catch (err) {
      setError("Could not access microphone. Please allow permission.");
      console.error("Microphone error:", err);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && recording) {
      mediaRecorderRef.current.stop();
      setRecording(false);
    }
    if (browserSupportsSpeechRecognition) {
      SpeechRecognition.stopListening();
    }
  };

  return (
    <div style={{ margin: "12px 0" }}>
      <button
        onClick={recording ? stopRecording : startRecording}
        style={{
          padding: "10px 24px",
          borderRadius: 12,
          background: recording ? "#ef476f" : "#217a53",
          color: "#fff",
          fontWeight: 600,
          border: "none",
          cursor: "pointer",
          marginRight: 10
        }}
        aria-label={recording ? "Stop recording" : "Start recording"}
        disabled={loading}
      >
        {recording ? "Stop Recording" : "Start Recording"}
      </button>
      {loading && <span style={{ marginLeft: 10 }}>Analyzing...</span>}
      {audioURL && (
        <audio src={audioURL} controls style={{ display: "block", marginTop: 8 }} />
      )}
      {browserSupportsSpeechRecognition && (
        <div style={{ marginTop: 8, color: "#217a53", fontSize: 15 }}>
          <b>Transcript:</b> {transcript}
        </div>
      )}
      {error && (
        <div style={{ color: "#ef476f", marginTop: 8 }}>{error}</div>
      )}
    </div>
  );
}
